import * as Actions from "@/store/actions.type";
import * as Mutations from "@/store/mutations.type";

export default {
  state: { region: "au" },
  mutations: {
    [Mutations.SET_REGION](state, region) {
      state.region = region;
    }
  },
  actions: {
    [Actions.SET_REGION]({ commit }, region) {
      commit(Mutations.SET_REGION, region);
    }
  },
  getters: {
    getRegion(state) {
      return state.region;
    }
  }
};
